const BaseColors = {
  // Lava (oranges / brand)
  lava: '#ff4a00',
  lava120: '#d93f00',
  lava80: '#ff6e33',
  lava60: '#ff9266',
  lava40: '#ffb799',
  lava20: '#ffdbcc',
  lava10: '#ffede6',
  lava5: '#fff6f2',
  // Ocean (blues)
  ocean: '#136bf5',
  ocean120: '#2655bd',
  ocean80: '#4289f7',
  ocean60: '#71a6f9',
  ocean40: '#a1c4fb',
  ocean20: '#d0e1fd',
  ocean10: '#e7f0fe',
  ocean5: '#f3f8ff',
  // Sun (yellows)
  sun: '#ffc43e',
  sun120: '#e6b038',
  sun80: '#ffd065',
  sun60: '#ffdc8b',
  sun40: '#ffe7b2',
  sun20: '#fff3d8',
  sun10: '#fff9ec',
  sun5: '#fffcf5',
  // Error
  error: '#e02d00',
  error10: '#ffe1d5',
  error120: '#b92602',
  // Warning
  warning: '#ffc43e',
  warning10: '#ffe7b2',
  // Success
  success: '#62d493',
  success10: '#daf5e6',
  // Grays
  gray: '#333333',
  gray80: '#424242',
  gray60: '#757575',
  gray40: '#cccccc',
  gray20: '#e6e6e6',
  gray10: '#f2f2f2',
  gray5: '#fafafa',
  // Special colors
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent',
  inherit: 'inherit',
  currentColor: 'currentColor',
} as const;

/** Alias common color assignments for consistency in implementations */
const ColorAliases = {
  brand: BaseColors.lava,
};

export const Colors = { ...BaseColors, ...ColorAliases };

export type ColorName = keyof typeof Colors;
export type ColorValue = typeof Colors[ColorName];
